<template>
  <footer class="footer">
    <nav class="navbar is-transparent is-spaced">
      <div class="navbar-menu">
        <div class="navbar-start">
          <prismic-link v-for="menuLink in menuLinks" class="navbar-item is-uppercase" :key="menuLink.id" :field="menuLink.link">{{ $prismic.richTextAsPlain(menuLink.label) }}</prismic-link>
        </div>
        <div class="navbar-end">
          <prismic-rich-text class="copyright" :field="copyright"/>
        </div>
      </div>
      <div class="footer-mobile">
        <div class="footer-mobile-links">
          <prismic-link v-for="menuLink in menuLinks" class="is-uppercase" :key="menuLink.id" :field="menuLink.link">{{ $prismic.richTextAsPlain(menuLink.label) }}</prismic-link>
        </div>
        <prismic-rich-text class="copyright" :field="copyright"/>
      </div>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'FooterPrismic',
  data () {
    return {
      copyright: "",
      menuLinks: []
    }
  },
  methods: {
    getFooter() {
      this.$prismic.client.getSingle('footer')
        .then((footerContent) => {
          this.copyright = footerContent.data.copyright;
        })

      this.$prismic.client.getSingle('menu')
        .then((menuContent) => {
          this.menuLinks = menuContent.data.menu_links
        })
    }
  },
  created () {
    this.getFooter()
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../assets/sass/colors.scss";

.footer {
  background: $navy;
  color: $white;

  .navbar-item, .navbar-link {
    color: $white;
    opacity: 1;
    -webkit-transition: opacity 0.2s ease-in-out;
    -moz-transition: opacity 0.2s ease-in-out;
    -ms-transition: opacity 0.2s ease-in-out;
    -o-transition: opacity 0.2s ease-in-out;
    transition: opacity 0.2s ease-in-out;
    &:hover {
      opacity: 0.7;
    }
  }

  .footer-mobile {
    padding: 0rem 1.5rem;
    @media screen and (min-width: $desktop) {
      display: none;
    }
    .footer-mobile-links {
      display: flex;
      justify-content: space-between;
      a {
        color: $white;
      }
    }
    .copyright {
      padding-top: 25px;
      text-align: center;
    }
  }
}

.icon-container {
  width: 100%;
  max-width: 150px;
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  padding: 15px 0;
  .icon-img {
    display: block;
    width: 24px;
    height: 24px;
    .svg {
      width: 24px;
      height: 24px;
    }
  }

  @media screen and (max-width: $tablet) {
    margin: auto;
  }
}

.navbar {
  background: transparent;
}

.navbar-item {
  padding: 0.5rem 1.5rem;
}

.above-footer {
  background: $lightBlue;
}

.navbar-end {
  display: flex;
  flex-direction: column;
}

.copyright {
  font-size: 12px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
